<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { HTMLText } from '@atoms';
	import type { ContentColumn } from './ColumnQuery';
	import { TextStyle } from '@atoms/text/TextStyle';

	let { data, theme = 'dark' }: { data: ContentColumn; theme?: string } = $props();
	createViewController();
</script>

<div class="container theme-{theme}" use:ViewController>
	<div class="left">
		<h3 class="text:description-small" use:EnterOnView>
			<span class="dot theme-{theme}"></span>{data.firstEyebrow}
		</h3>
		<div use:EnterOnView={{ delay: 0.2 }}>
			<HTMLText style={TextStyle.Large} text={data.firstDescription} />
		</div>
	</div>

	<div class="right">
		<h3 class="text:description-small" use:EnterOnView={{ delay: 0.1 }}>
			<span class="dot theme-{theme}"></span>{data.secondEyebrow}
		</h3>

		<div use:EnterOnView={{ delay: 0.3 }}>
			<HTMLText style={TextStyle.Large} text={data.secondDescription} />
		</div>
	</div>
</div>

<style lang="scss">
	.container {
		display: flex;
		justify-content: space-between;
		width: 100%;
		gap: 40px;

		flex-direction: column;

		@include md {
			gap: 20px;
			flex-direction: row;
			min-height: 300px;
		}
	}

	.left,
	.right {
		width: 50%;
	}

	.dot {
		background-color: hsl(var(--color-primary));
		width: 10px;
		height: 10px;
		border-radius: 50%;
		display: inline-block;
		margin-right: 20px;

		&.theme-light {
			background-color: hsl(var(--color-foreground));
		}
	}

	h3 {
		padding-bottom: 20px;

		@include md {
			padding-bottom: 40px;
		}
	}
</style>
